import { EditorActions } from '../../utils/editor-actions';
import { AppDescriptor, CustomActionConfig } from '@wix/platform-editor-sdk';
import { DeafultOptions } from './app-descriptor.const';
import { Translations } from '../../utils/translations';
import { getAsset } from '../../utils/get-asset';

export default function createAppDescriptor(
  actions: EditorActions,
  isPremium: boolean,
  translation: Translations,
  currentVersion: string,
  isEditor3?: boolean,
): AppDescriptor {
  const upgrade = {
    upgradeType: DeafultOptions.SITE_UPGRADE as DeafultOptions.SITE_UPGRADE,
    upgradeText: translation.t('bookings-descriptor.actions.upgrde-text'),
    upgradeLinkText: translation.t(
      'bookings-descriptor.actions.upgrde-link-text',
    ),
  };

  const manageServices: Partial<CustomActionConfig> = {
    title: actions.manageBookingsAction.label,
    actionId: actions.manageBookingsAction.actionId,
    icon: 'appManager_settingsAction',
  };
  const createAService: Partial<CustomActionConfig> = {
    title: actions.createAService.label,
    actionId: actions.createAService.actionId,
    icon: 'appManager_addElementsAction',
  };
  const openAddPanel: CustomActionConfig = {
    title: actions.openAddPanel.label,
    actionId: actions.openAddPanel.actionId,
    icon: 'appManager_addElementsAction',
    type: 'editorActions',
  };
  const openPagesPanel: CustomActionConfig = {
    title: actions.openPagesPanel.label,
    actionId: actions.openPagesPanel.actionId,
    icon: 'appManager_pagesAction',
    type: 'editorActions',
  };

  const manageStaffMembers: Partial<CustomActionConfig> = {
    title: actions.manageStaffAction.label,
    actionId: actions.manageStaffAction.actionId,
    icon: 'users',
  };

  const manageClientFlow: Partial<CustomActionConfig> = {
    title: actions.manageClientFlowAction.label,
    actionId: actions.manageClientFlowAction.actionId,
    icon: 'wrap',
  };

  const openManageAvailability: Partial<CustomActionConfig> = {
    title: actions.openManageAvailability.label,
    actionId: actions.openManageAvailability.actionId,
    icon: 'dateAndTime',
  };

  const openBookingsSettings: Partial<CustomActionConfig> = {
    title: actions.openBookingsSettings.label,
    actionId: actions.openBookingsSettings.actionId,
    icon: 'appManager_manageStaffAction',
  };

  const openSharableLinks: Partial<CustomActionConfig> = {
    title: actions.openSharableLinks.label,
    actionId: actions.openSharableLinks.actionId,
    icon: 'bookingChannels',
  };

  const openIntegrations: Partial<CustomActionConfig> = {
    title: actions.openIntegrations.label,
    actionId: actions.openIntegrations.actionId,
    icon: 'integrations',
  };

  const openCalendar: Partial<CustomActionConfig> = {
    title: actions.openCalendar.label,
    actionId: actions.openCalendar.actionId,
    icon: 'date',
  };

  const upgradeOffer = {
    upgradeType: DeafultOptions.SITE_UPGRADE as DeafultOptions.SITE_UPGRADE,
    upgradeText: translation.t('bookings-descriptor.offers.upgrade-text'),
    upgradeLinkText: translation.t(
      'bookings-descriptor.offers.upgrade-link-text',
    ),
  };

  if (isEditor3) {
    return {
      mainActions: [
        manageServices as CustomActionConfig,
        openCalendar as CustomActionConfig,
        manageClientFlow as CustomActionConfig,
        openSharableLinks as CustomActionConfig,
        manageStaffMembers as CustomActionConfig,
      ],
      customActions: [
        openManageAvailability as CustomActionConfig,
        openIntegrations as CustomActionConfig,
        openBookingsSettings as CustomActionConfig,
      ],
      defaultActions: {
        learnMoreKB: DeafultOptions.LEARN_MORE_ID,
        ...(!isPremium ? { upgrade: upgradeOffer } : {}),
      },
      application: {
        name: translation.t('businessPanel.header.title'),
        editorSetup: {
          title: translation.t('businessPanel.startOffering.title'),
          description: translation.t('businessPanel.startOffering.subtitle'),
        },
        pages: {
          images: [
            getAsset(currentVersion, 'images/calendar.png'),
            getAsset(currentVersion, 'images/services-list.png'),
          ],
        },
      },
    };
  }

  return {
    mainActions: [
      manageServices as CustomActionConfig,
      createAService as CustomActionConfig,
    ],
    customActions: [openAddPanel, openPagesPanel],
    defaultActions: {
      learnMoreKB: DeafultOptions.LEARN_MORE_ID,
      ...(!isPremium ? { upgrade } : {}),
    },
  };
}
